import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { CompareBarProduct } from '@shared/data-access/interfaces';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';

@Component({
    selector: 'plp-components-compare-thumbnail',
    imports: [CommonModule, HomefieldIconLibraryModule, HmfButtonComponent],
    templateUrl: './compare-thumbnail.component.html',
    styleUrl: './compare-thumbnail.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompareThumbnailComponent {
	@Input() compareData: CompareBarProduct | null = null;

	@Output() remove = new EventEmitter<string>();

	onRemove () {
		this.remove.emit(this.compareData?.ecode);
	}
}
